import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import styles from "./FeaturedTeaching.module.css";
import Image from "next/image";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";

import InstituteLogo from "../../../assets/imgs/yakin-logo.png";
//import InstituteLogo from "../../../assets/imgs/featured-img-full.png";
import FeaturedImg1 from "../../../assets/imgs/featured-img-1.png";
import FeaturedImg2 from "../../../assets/imgs/featured-img-2.png.png";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../utils/axiosInstance";
import SimpleBackdrop from "../../Backdrop/SimpleBackdrop";
import { useRouter } from "next/navigation";


const FeaturedTeaching = () => {

  const router = useRouter();

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [featuredOrganization, setFeaturedOrganization] = useState(null);
  const [orgCourses, setOrgCourses] = useState([])
  

  const getActiveFeaturedOrganization = async () => {
    setOpenBackdrop(true);
    try {
      const data = await apiRequest(
        "/getActiveFeaturedOrganization",
        "GET",
        null
      );
      if (!data?.error) {
        setFeaturedOrganization(data?.data)
        
      }
      setOpenBackdrop(false);
    } catch (error) {
      console.log(error);
      setOpenBackdrop(false);
    }
  }

  useEffect(() => {
    if(featuredOrganization){
      setOrgCourses(featuredOrganization?.courses?.map(singleCourse => ({
        img: singleCourse?.courseImage,
        name: singleCourse?.courseTitle || "N/A",
        courseFormat: singleCourse?.courseFormat || "N/A",
        onClick: () => {
          router.push(`/learn/${singleCourse?.courseSlug}`)
        }
      })))
    }
  }, [featuredOrganization])
  
  useEffect(() => {
    
    getActiveFeaturedOrganization()
    
  },[])



  const courses = [
    {
      img: FeaturedImg1,
      name: "Arabic Language: The Complete Course (Diploma)",
      //onClick:onClick;
    },
    {
      img: FeaturedImg2,
      name: "Arabic Language: The Complete Course (Diploma)",
      //onClick:onClick;
    },
  ];

  const handleCloseBackdrop = () => {
    // setOpenBackdrop(false);
  };

  return (
    <>
    <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
    <div className="Section" style={{ paddingTop: "72px", marginBottom: "0px", paddingBottom:"0" }}>
      <Container maxWidth="lg" sx={{ maxWidth: "1000px !important;" }}>
        <div className={styles.FeaturedContainer}>
          <div className={styles.FeaturedLogoContainer}>
            <img src={featuredOrganization?.officialLogo} />
          </div>
          <div className={styles.FeaturedDetails}>
            <div className={styles.FeaturedTitle}>{featuredOrganization?.teachingAccName}</div>
            {(featuredOrganization?.accountType == "org") && <div className={styles.FeaturedSubTitle}>{featuredOrganization?.orgType}</div>}

            {orgCourses?.map((item, i) => (
              <div className={styles.FeaturedListing}>
                <div className={styles.FeaturedCourse}>
                  {item?.courseFormat == "live" && <div className={styles.Live}>LIVE</div>}
                  <img src={item.img} />
                </div>

                <div className={styles.FeaturedCourseDetails}>
                  <div className={styles.FeaturedCourseName}>{item.name}</div>
                  <div className={styles.ViewCourse}>
                    <Button
                      className={styles.ViewCourseButton}
                      variant="text"
                      onClick={item.onClick}
                    >
                      View course <ArrowForwardIcon />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
    </>
  );
};

export default FeaturedTeaching;
